import { Injectable } from '@angular/core';
import { InspectorDialogComponent } from '../inspector-dialog/inspector-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})

export class QBuiltInspectorDialogService {
  constructor(private dialog: MatDialog) {}

  openInspectorDialog(dialogType: number, dataList?: any[], userName?: string) {
    const dialogRef = this.dialog.open(InspectorDialogComponent, {
      data: {
        dialogType: dialogType,
        dataList: dataList,
        userName: userName
      }
    });

    return dialogRef;
  }

}